import { render, staticRenderFns } from "./Scene4.vue?vue&type=template&id=0e4cc84e&scoped=true"
import script from "./Scene4.vue?vue&type=script&lang=js"
export * from "./Scene4.vue?vue&type=script&lang=js"
import style0 from "./Scene4.vue?vue&type=style&index=0&id=0e4cc84e&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e4cc84e",
  null
  
)

export default component.exports